import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackClickedCanvasNullStateSuggestion.meta';

export type UseTrackClickedCanvasNullStateSuggestionParams = {
  suggestion_id: 'smart_resize' | 'run_skill' | 'convert_image';
};

export const useTrackClickedCanvasNullStateSuggestion = () => {
  const { track } = useAnalyticsUtilities();

  const trackClickedCanvasNullStateSuggestion = useCallback(
    (params: UseTrackClickedCanvasNullStateSuggestionParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackClickedCanvasNullStateSuggestion };
};
